(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector = [
    "main[data-template='index'] > .shopify-section",
    "main[data-template='index'] .section-resource-list__header",
    "main[data-template='index'] .resource-list__item",
    "main[data-template='index'] .hero__content-wrapper > *",
    "main[data-template='index'] .rkb-hero__copy",
    "main[data-template='index'] .rkb-intro__inner",
    "main[data-template='index'] .rkb-products__header",
    "main[data-template='index'] .rkb-product",
    "main[data-template='index'] .rkb-image-text__media",
    "main[data-template='index'] .rkb-image-text__copy-inner",
    "main[data-template='index'] .rkb-cards__header",
    "main[data-template='index'] .rkb-card",
    "main[data-template='index'] .rkb-category",
    "main[data-template='index'] .rkb-promise",
    "main[data-template='index'] .rkb-testimonials__header",
    "main[data-template='index'] .rkb-review",
    "main[data-template='index'] .rkb-product-slider__header",
    "main[data-template='index'] .rkb-slider-card",
  ].join(',');

  let observer;
  let lastScrollY = window.scrollY;
  let scrollDirection = 'down';
  let rafId = 0;

  const updateDirection = () => {
    const currentScrollY = window.scrollY;
    if (Math.abs(currentScrollY - lastScrollY) > 3) {
      scrollDirection = currentScrollY > lastScrollY ? 'down' : 'up';
      lastScrollY = currentScrollY;
    }
    rafId = 0;
  };

  const onScroll = () => {
    if (!rafId) rafId = window.requestAnimationFrame(updateDirection);
  };

  const revealImmediately = (root = document) => {
    root.querySelectorAll?.(selector).forEach((element) => {
      element.classList.add('robot-reveal', 'is-visible');
    });
  };

  const observe = (root = document) => {
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      revealImmediately(root);
      return;
    }

    root.querySelectorAll?.(selector).forEach((element, index) => {
      if (element.dataset.robotRevealReady === 'true') return;

      element.dataset.robotRevealReady = 'true';
      element.classList.add('robot-reveal');
      element.style.setProperty('--robot-reveal-delay', `${Math.min(index % 4, 3) * 70}ms`);
      observer.observe(element);
    });
  };

  const setup = () => {
    observer?.disconnect();
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const element = entry.target;

          if (entry.isIntersecting) {
            element.dataset.revealFrom = scrollDirection === 'up' ? 'top' : 'bottom';
            window.requestAnimationFrame(() => element.classList.add('is-visible'));
          } else {
            element.classList.remove('is-visible');
            element.dataset.revealFrom = entry.boundingClientRect.top < 0 ? 'top' : 'bottom';
          }
        });
      },
      {
        root: null,
        rootMargin: '7% 0px 7% 0px',
        threshold: 0.12,
      }
    );

    observe(document);
  };

  const init = () => {
    if (!document.querySelector("main[data-template='index']")) return;
    window.addEventListener('scroll', onScroll, { passive: true });
    setup();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => observe(event.target));
  reduceMotion.addEventListener?.('change', setup);
})();
